import {BaseAuditableDto} from '../../../../../../shared/model/core/baseAuditableDto.model';
import {ProductSummaryModel} from '../../../../../product/api/entity/productSummary.model';
import {Moment} from "moment";

export class SaleProductSummaryModel extends BaseAuditableDto {

    id: number;
    product: ProductSummaryModel;
    discountRate: number;
    quantity: number;
    unitPriceVatExcluded: number;
    unitPriceVatIncluded: number;
    vatRate: number;
    totalVat: number;
    totalPriceVatExcluded: number;
    totalPriceVatIncluded: number;
    comment: string;
    dateTime: Moment;

}
